class HomeController {
  constructor(flash) {
    this.flash = flash;
  }
}

export default {
  name: 'HomeController',
  fn: HomeController
};
